import script from "./brandListFoot.vue?vue&type=script&setup=true&lang=js"
export * from "./brandListFoot.vue?vue&type=script&setup=true&lang=js"

import "./brandListFoot.vue?vue&type=style&index=0&id=726553e8&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726553e8"]])

export default __exports__